import debounce from "lodash/debounce";
import React from "react";

import { useHandler } from "~/tools/use-handler";

export function useDebounce<TArgs extends Array<unknown>>(
	callback: (...args: TArgs) => void,
	wait = 500,
): (...args: TArgs) => void {
	const stableCallback = useHandler(callback);
	const debouncedCallback = React.useMemo(() => debounce(stableCallback, wait), [stableCallback, wait]);

	React.useEffect(() => () => debouncedCallback.cancel(), [debouncedCallback]);

	return debouncedCallback;
}
